import React from 'react'
import { UnpaidShiftsProvider } from './context/UnpaidShiftsProvider'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { UnpaidShiftsMain } from './components/UnpaidShiftsMain'

export const UnpaidShifts = () => {
  return (
    <NuqsAdapter>
      <UnpaidShiftsProvider>
        <UnpaidShiftsMain />
      </UnpaidShiftsProvider>
    </NuqsAdapter>
  )
}
